export const isTimestampInRange = (callTimestamp, startTimeSeconds, nextStartTimeSeconds) => {
  if (!callTimestamp) return false;
  const commentTime = Number(callTimestamp);
  const startTime = Math.floor(startTimeSeconds);
  if (nextStartTimeSeconds !== undefined) {
    return commentTime >= startTime && commentTime < Math.floor(nextStartTimeSeconds);
  }
  return commentTime >= startTime;
};
export const getEarliestComment = comments => {
  if (comments.length === 0) return null;
  return comments.reduce((earliest, current) => {
    return new Date(current.createdAt) < new Date(earliest.createdAt) ? current : earliest;
  });
};